import _ from 'lodash';
import moment from 'moment';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

//- material-ui
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import UpIcon from '@material-ui/icons/ArrowDropUp';
import DownIcon from '@material-ui/icons/ArrowDropDown';

//- local
import GasBuddyPricesContainer from '../../containers/reports/GasBuddyPrices';
import GasBuddyIgnoredStationsContainer from '../../containers/reports/GasBuddyIgnoredStations';
import ReportsMonitoringContainer from '../../containers/reports/Monitoring';
import RegistryContainer from '../../containers/Registry';
import { sortStationTable } from '../../libs/utility';
import FMPHeadline from '../../components/ui/FMPHeadline';
// import AddRetailPrice from "../../components/AddRetailPrice";
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';

import { getSharedStyles } from '../../themes';
import FMPStationSelect from '../../components/pureForm/FMPStationSelect';
import FormComponent from '../../components/FormComponent';
import StationsContainer from '../../containers/Stations';
import EnhancedTable from '../../components/table/EnhancedTable';
import clsx from 'classnames';
import { post } from '../../modules/utility';
import FMPText from '../../components/pureForm/FMPText';
const styles = (theme) => ({
	...getSharedStyles(theme),
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 17px 8px 10px',
		borderRadius: '30px',
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	label: {},
	value: {
		fontWeight: 600,
	},
	errorRow: {
		backgroundColor: '#FECDD1',
		//backgroundColor : '#FFECF0',
	},
	reportedDateTime: {
		fontWeight: 200,
		color: '#666',
		whiteSpace: 'nowrap',
	},
	upDownIcon: {
		marginTop: -9,
		bottom: -9,
		width: 28,
		height: 28,
		position: 'relative',
	},
	reportInfo: {
		textAlign: 'left',
		padding: '10px 10px',
	},
	controlButton: {
		borderRadius: 100,
		textDecoration: 'none',
		marginTop: 10,
	},
	downloadIcon: {
		marginRight: 5,
	},
	currentEmail: {
		fontSize: 18,
		paddingLeft: 10,
		lineHeight: 1.7,
	},
	helpText: {
		border: '1px solid #eee',
		backgroundColor: '#f7f7f',
		padding: 15,
		margin: 15,
		fontSize: 14,
		color: '#333',
	},
	howCalculated: {
		fontSize: 16,
		color: '#777',
		paddingBottom: 5,
		paddingTop: 10,
		display: 'flex',
		alignItems: 'center',
	},
	analysisTitle: {
		fontWeight: 600,
		fontSize: 17,
		color: '#555',
		paddingBottom: 5,
		paddingTop: 20,
	},
	statLabel: {
		color: '#555',
	},
	statValue: {
		fontWeight: 600,
	},
	subLabel: {
		fontSize: 13,
		color: '#777',
	},
	statTable: {
		border: `1px solid #ddd`,
		padding: 20,
		tableLayout: 'auto',
		backgroundColor: 'white',
		width: '100%',
	},
	stationBreakdownTable: {
		padding: 20,
		tableLayout: 'auto',
		backgroundColor: 'white',
		//width: '100%',
		borderCollapse: 'collapse',
	},
	analysisContainer: {
		//border : `1px solid #ddd`,
		//padding : 20,
	},
	statRow: {
		margin: 0,
		backgroundColor: '#fff',
		fontsize: 16,
	},
	evenRow: {
		backgroundColor: '#eee',
	},
	td: {
		padding: 15,
		whiteSpace: 'nowrap',
	},
});

const gasBuddyIgnoredStationColumns = [
	{ sortId: 'stationDisplay', displayId: 'stationDisplay', label: 'Station' },
	{ sortId: 'createdByDisplay', displayId: 'createdByDisplay', label: 'Created By' },
	{ sortId: 'dateCreated', displayId: 'dateCreatedDisplay', label: 'Date Created' },
	{ sortId: 'reasonForIgnore', displayId: 'reasonForIgnore', label: 'Reason' },
	{
		sortId: 'gasBuddyIgnoredStationId',
		displayId: 'actions',
		label: 'Actions',
		isNotSortable: true,
	},
];

function getYearMonth({ date }) {
	return `${date.year()}_${date.month()}`;
}

class AddAndIgnoreRetailPricing extends FormComponent {
	constructor(props) {
		super(props);

		this.state = {
			order: 'desc',
			orderBy: 'freshnessSort',
			search: '',
			gasBuddyAlertEmail: undefined,
			gasBuddyIgnoredStationFormattedRows: [],
			updateModalOpen: false,
			selectedStationForUpdate: null,
			updateReasonForIgnore: '',
		};
		//  this.registryIdForGasBuddyAlert = undefined;
		this.handleRowClick = this.handleRowClick.bind(this);
		this.handleRequestSort = this.handleRequestSort.bind(this);
		this.handleSearch = this.handleSearch.bind(this);

		this.currentMonth = moment();
		this.lastMonth = moment().subtract(1, 'month');
	}

	monthCheck({ date }) {
		const year = date.year();
		const month = date.month();
		const yearMonth = getYearMonth({ date });

		if (!this.props.salesByMonth[yearMonth]) {
			this.props.getMonthlySales({ params: { year, month } });
		}
	}

	componentDidMount() {
		const { gasBuddyIgnoredStations, gasBuddyIgnoredStationSearch } = this.props;

		this.getStationIdsInRebateProgram();

		if (!gasBuddyIgnoredStations) {
			gasBuddyIgnoredStationSearch();
		} else {
			this.gasBuddyIgnoredStationFormat();
		}

		if (!this.props.latestGasBuddyPrices) {
			this.props.getLatestGasBuddyPrices({});
		}
		if (!this.props.registryRows) {
			this.props.searchRegistry({});
		}
		if (_.isEmpty(this.props.stations)) {
			this.props.searchStations();
		}

		this.monthCheck({ date: this.currentMonth });
		this.monthCheck({ date: this.lastMonth });
	}

	componentDidUpdate(prevProps) {
		const { registryRows } = this.props;
		if (!prevProps.registryRows && registryRows) {
			const gasBuddyRow = _.find(registryRows, { name: 'gasBuddyAlertEmail' });
			// this.registryIdForGasBuddyAlert = gasBuddyRow.registryId;

			if (!this.state.gasBuddyAlertEmail) {
				this.setState({ gasBuddyAlertEmail: gasBuddyRow.val });
			}
		}

		const { gasBuddyIgnoredStations } = this.props;
		if (
			JSON.stringify(gasBuddyIgnoredStations) !== JSON.stringify(prevProps.gasBuddyIgnoredStations)
		) {
			this.gasBuddyIgnoredStationFormat();
		}
	}

	getStationIdsInRebateProgram = () => {
		const { showErrors } = this.props;
		post({
			method: 'report.sales.getStationIdsInRebateProgram',
			params: {},
			callback: (err, apiResults) => {
				if (err) {
					showErrors(err);
				}
				this.setState({ stationIdsInRebateProgram: apiResults.stationIds });
			},
		});
	};

	gasBuddyIgnoredStationFormat = () => {
		const { classes } = this.props;
		const { gasBuddyIgnoredStations, stationMap, userMap } = this.props;

		gasBuddyIgnoredStations.forEach((gasBuddyIgnoredStation) => {
			const {
				gasBuddyIgnoredStationId,
				stationId,
				createdByUserId,
				dateCreated,
			} = gasBuddyIgnoredStation;
			const station = stationMap[stationId] || { name: 'Missing' };
			const user = userMap[createdByUserId] || { firstName: 'Missing', lastName: '' };

			gasBuddyIgnoredStation.key = gasBuddyIgnoredStationId;
			gasBuddyIgnoredStation.stationDisplay = `${station.number} - ${station.name}`;
			gasBuddyIgnoredStation.createdByDisplay = user.firstName;
			gasBuddyIgnoredStation.dateCreatedDisplay = moment(dateCreated).format('dddd, M/D/YY h:mm a');

			gasBuddyIgnoredStation.actions = (
				<>
					<div style={{ display: 'flex', gap: 10 }}>
						<Button
							className={classes.button}
							onClick={() => this.handleOpenUpdateModal(gasBuddyIgnoredStation)}
						>
							Update
						</Button>

						<Button
							className={classes.button}
							onClick={() => this.handleRemoveIgnoredStation(gasBuddyIgnoredStationId)}
						>
							Remove
						</Button>
					</div>
				</>
			);
		});
		this.setState({ gasBuddyIgnoredStationFormattedRows: gasBuddyIgnoredStations });
	};

	handleRemoveIgnoredStation = (gasBuddyIgnoredStationId) => {
		const { gasBuddyIgnoredStationRemove } = this.props;
		gasBuddyIgnoredStationRemove({ gasBuddyIgnoredStationId });
	};

	handleOpenUpdateModal = (station) => {
		this.setState({
			updateModalOpen: true,
			selectedStationForUpdate: station,
			updateReasonForIgnore: station.reasonForIgnore || '',
		});
	};

	handleCloseUpdateModal = () => {
		this.setState({
			updateModalOpen: false,
			selectedStationForUpdate: null,
			updateReasonForIgnore: '',
		});
	};

	handleUpdateReason = (value) => {
		this.setState({ updateReasonForIgnore: value });
	};

	handleUpdateIgnoredStation = () => {
		const { selectedStationForUpdate, updateReasonForIgnore } = this.state;
		const { showErrors, gasBuddyIgnoredStationUpdate } = this.props;

		if (!updateReasonForIgnore.trim()) {
			return showErrors(['Please provide a reason for ignoring this station.']);
		}

		const params = {
			gasBuddyIgnoredStationId: selectedStationForUpdate.gasBuddyIgnoredStationId,
			reasonForIgnore: updateReasonForIgnore.trim(),
		};

		gasBuddyIgnoredStationUpdate({ params, callback: () => this.handleCloseUpdateModal() });
		//this.handleCloseUpdateModal();
	};

	handleAddIgnoredStation = () => {
		const { stationId, reasonForIgnore } = this.state;
		const { showErrors, gasBuddyIgnoredStationAdd } = this.props;
		if (!stationId) {
			return showErrors(['Hello McFly? You have to pick a station first.']);
		}
		const params = {
			stationId,
			reasonForIgnore,
		};
		gasBuddyIgnoredStationAdd({ params });
	};

	handleSearch(event) {
		this.setState({ search: event.target.value });
	}

	handleRowClick(stationId) {
		this.props.history.push(`/reports/retailPricesForStation/${stationId}`);
	}

	handleRequestSort(property) {
		const orderBy = property;
		let order = 'desc';

		// noinspection JSValidateTypes
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	}

	getDailyAverageByStationId = ({ currentMonthData }) => {
		let dailyAverageByStationId = {};
		currentMonthData.tankDailySales.forEach((tankDailySale) => {
			const { stationId, dailyAverage, isGmoc } = tankDailySale;
			if (!dailyAverageByStationId[stationId]) {
				dailyAverageByStationId[stationId] = 0;
			}
			if (isGmoc) {
				return;
			}
			dailyAverageByStationId[stationId] += _.round(dailyAverage);
		});
		return dailyAverageByStationId;
	};

	render() {
		const {
			latestGasBuddyPrices,
			registryRows,
			classes,
			stationMap,
			authUser,
			salesByMonth,
			userMap,
		} = this.props;

		if (!salesByMonth || !latestGasBuddyPrices || !registryRows || !stationMap || !authUser) {
			return <div>Fetching data...</div>;
		}

		//- Get daily sales
		const currentYearMonth = getYearMonth({ date: this.currentMonth });
		const currentMonthData = salesByMonth[currentYearMonth];
		if (!currentMonthData) {
			return <div>Calculating monthly sales...</div>;
		}

		const dailyAverageByStationId = this.getDailyAverageByStationId({ currentMonthData });

		const {
			order,
			orderBy,
			search,
			stationIdsInRebateProgram,
			gasBuddyIgnoredStationFormattedRows,
		} = this.state;
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		const cleanSearch = search.replace(/[^a-z0-9]/gi, '');
		const re = new RegExp('^' + cleanSearch, 'i');

		//- This has all the gasBuddy prices for the last 7 days so I have to group by station
		const rowsByStationId = _.groupBy(latestGasBuddyPrices, 'stationId');

		//const gasBuddyRow = _.find(registryRows, { name : 'gasBuddyAlertEmail'});

		let gasBuddyRows = [];
		const previousPrices = [];
		const recentPrices = [];
		const margins = [];
		const now = moment();

		const ignoreByStationId = _.keyBy(gasBuddyIgnoredStationFormattedRows, 'stationId');
		const rebateByStationId = _.keyBy(stationIdsInRebateProgram);

		_.values(rowsByStationId).forEach((rowsForStation) => {
			const ordered = _.orderBy(rowsForStation, 'reportedDateTime', 'desc');

			if (ordered.length >= 2) {
				const recent = ordered[0];
				const previous = ordered[1];

				const { stationId, number, name, contactName, contactPhoneNumber } = stationMap[
					recent.stationId
				];

				//- filter first
				if (search && !re.test(number) && !re.test(name)) {
					return;
				}

				/** @namespace recent.gasBuddyPrice **/
				/** @namespace recent.quotedPrice **/
				/** @namespace recent.totalCost **/
				/** @namespace recent.reportedDateTime **/
				/** @namespace previous.gasBuddyPrice **/
				/** @namespace previous.reportedDateTime **/

				const diff = _.round(recent.gasBuddyPrice - previous.gasBuddyPrice, 3);
				let diffIcon = '';
				if (diff > 0) {
					diffIcon = <UpIcon className={classes.upDownIcon} />;
				} else if (diff < 0) {
					diffIcon = <DownIcon className={classes.upDownIcon} />;
				}

				previousPrices.push(previous.gasBuddyPrice);
				recentPrices.push(recent.gasBuddyPrice);
				const estimatedMargin = _.round(recent.gasBuddyPrice - recent.totalCost, 3);
				margins.push(estimatedMargin);
				const rowClick = () => this.handleRowClick(stationId);

				const currentMonthDailyAverage = dailyAverageByStationId[stationId] || '-';

				let recentSourceDisplay = 'OPIS';
				if (recent.createdByUserId) {
					const user = userMap[recent.createdByUserId] || { firstName: 'Missing', lastName: '' };
					recentSourceDisplay = `${user.firstName}`;
				}

				const recentMoment = moment(recent.reportedDateTime);
				const freshnessSort = now.diff(recentMoment);
				const freshnessDisplay = moment.duration(now.diff(recentMoment)).humanize();

				gasBuddyRows.push({
					isIgnored: !!ignoreByStationId[stationId],
					isInRebate: !!rebateByStationId[stationId],
					stationId,
					number,
					name,

					previousPrice: previous.gasBuddyPrice,
					previousReportedDateTime: moment(previous.reportedDateTime).format('M/D/YY h:mm a'),

					recentPrice: recent.gasBuddyPrice,
					recentReportedDateTime: moment(recent.reportedDateTime).format('M/D/YY h:mm a'),
					recentSourceDisplay,
					diff: diff,
					absDiff: Math.abs(diff),
					freshnessSort,
					freshnessDisplay,
					diffIcon: diffIcon,
					recentQuotedPrice: recent.quotedPrice,
					recentTotalCost: recent.totalCost,
					currentMonthDailyAverage,
					contact: (
						<Fragment>
							<div>{contactName}</div>
							<div>{contactPhoneNumber}</div>
						</Fragment>
					),
					rowClick,
					estimatedMargin,
				});
			}
		});

		gasBuddyRows = sortStationTable({ rows: gasBuddyRows, orderBy, order });

		const currentEmails = ['dispatch@pearsonfuels.com', 'dvind@pearsonfuels.com'];

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					{canMakeUpdates && (
						<div style={{ textAlign: 'left', marginBottom: 30 }}>
							<Grid container spacing={3}>
								<Grid item xs={6}>
									<Typography variant="h5" align="left" gutterBottom>
										Retail Price Alert Settings
									</Typography>
								</Grid>
							</Grid>
							<Paper className={classes.paper}>
								<Grid container spacing={3}>
									<Grid item xs={4}>
										<FMPSectionHeader label={'Current emails for alerts'} isTop={true} />
										{currentEmails.map((currentEmail) => {
											return (
												<div key={currentEmail} className={classes.currentEmail}>
													{currentEmail}
												</div>
											);
										})}
									</Grid>
								</Grid>
							</Paper>
						</div>
					)}

					<div style={{ marginTop: 20 }}>
						<Grid container spacing={3}>
							<Grid item xs={8}>
								<FMPHeadline label={'Stations To Ignore Pricing'} />
							</Grid>
						</Grid>

						<Paper className={classes.paper}>
							<div className={classes.helpText}>
								Adding stations here means we will not display their pricing on our website or in
								our app because we are unsure / can&apos;t trust the current price published by Gas
								Buddy.
							</div>

							<Grid container spacing={3} style={{ alignItems: 'center' }}>
								<Grid item xs={5}>
									<FMPStationSelect
										{...this.setForm(`stationId`, 'Station to Ignore', true)}
										contained={true}
										stations={this.props.stations}
									/>

									<FMPText
										{...this.setForm(`reasonForIgnore`, 'Reason for ignore', true)}
										contained={true}
										multiline={2}
									/>
								</Grid>
								<Grid item xs={3}>
									<Button
										variant="contained"
										color="primary"
										style={{ borderRadius: '30px' }}
										onClick={this.handleAddIgnoredStation}
									>
										Add Station to Ignore List
									</Button>
								</Grid>
							</Grid>

							<Grid container spacing={3} style={{ alignItems: 'center' }}>
								<Grid item xs={12}>
									<EnhancedTable
										columns={gasBuddyIgnoredStationColumns}
										rows={gasBuddyIgnoredStationFormattedRows}
										defaultOrder={'asc'}
										defaultOrderBy={'dateCreated'}
										isDense={true}
									/>
								</Grid>
							</Grid>
						</Paper>
					</div>
				</Grid>

				{/* Update Modal */}
				<Dialog
					open={this.state.updateModalOpen}
					onClose={this.handleCloseUpdateModal}
					maxWidth="sm"
					fullWidth
				>
					<DialogTitle>Update Reason for Ignoring Station</DialogTitle>
					<DialogContent>
						<Grid container spacing={2} style={{ marginTop: 10 }}>
							<Grid item xs={12}>
								<Typography variant="body1" gutterBottom>
									<strong>Station:</strong> {this.state.selectedStationForUpdate?.stationDisplay}
								</Typography>
							</Grid>
							<Grid item xs={12}>
								<FMPText
									value={this.state.updateReasonForIgnore}
									onChange={this.handleUpdateReason}
									path="updateReasonForIgnore"
									label="Reason for Ignoring"
									multiline={3}
									required
								/>
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleCloseUpdateModal} color="primary">
							Cancel
						</Button>
						<Button onClick={this.handleUpdateIgnoredStation} color="primary" variant="contained">
							Update
						</Button>
					</DialogActions>
				</Dialog>
			</Grid>
		);
	}

	drawOverallStats = ({ overallStats }) => {
		const { classes } = this.props;
		return (
			<>
				{overallStats.map((stat, i) => {
					const isOdd = i % 2;
					const { value, label, subLabel } = stat;
					return (
						<tr key={i} className={clsx(classes.statRow, !isOdd ? classes.evenRow : '')}>
							<td className={classes.td} style={{ textAlign: 'left' }}>
								<div className={classes.statLabel}>{label}</div>
								{subLabel && <div className={classes.subLabel}>{subLabel}</div>}
							</td>
							<td className={clsx(classes.td, stat.diffClass)} style={{ textAlign: 'right' }}>
								{stat.diffIcon && stat.diffIcon}
								<span className={classes.statValue}>{value}</span>
							</td>
						</tr>
					);
				})}
			</>
		);
	};
}

AddAndIgnoreRetailPricing.propTypes = {
	classes: PropTypes.object.isRequired,
	getMonthlySales: PropTypes.func.isRequired,
	salesByMonth: PropTypes.object,

	getLatestGasBuddyPrices: PropTypes.func.isRequired,
	latestGasBuddyPrices: PropTypes.array,

	gasBuddyIgnoredStationSearch: PropTypes.func.isRequired,
	gasBuddyIgnoredStationAdd: PropTypes.func.isRequired,
	gasBuddyIgnoredStationRemove: PropTypes.func.isRequired,
	gasBuddyIgnoredStationUpdate: PropTypes.func.isRequired,
	gasBuddyIgnoredStations: PropTypes.array,

	stationMap: PropTypes.object,
	userMap: PropTypes.object,

	searchRegistry: PropTypes.func,
	updateRegistry: PropTypes.func,
	registryRows: PropTypes.array,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
	accessToken: PropTypes.string,
	stations: PropTypes.array,
	searchStations: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	ReportsMonitoringContainer,
	GasBuddyPricesContainer,
	GasBuddyIgnoredStationsContainer,
	RegistryContainer,
	StationsContainer,
])(AddAndIgnoreRetailPricing);
